export default __webpack_public_path__ + "static/media/background_filters_dashboard.43fd0eca.png";